import { render, staticRenderFns } from "./AgreementsHome.vue?vue&type=template&id=2f076491&scoped=true"
import script from "./AgreementsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f076491",
  null
  
)

export default component.exports